export default {
  data() {
    return {
      show: false,
      payload: {}
    }
  },

  methods: {
    open(modalData) {
      this.show = true
      this.fromBus = modalData
    },

    close() {
      this.show = false
      this.fromBus = {}
    },

    setOpenListener(name) {
      this.$bus.$on('openModal', (payload) => {
        if (payload.name === name) {
          this.open(payload.data)
        }
      })
    }
  },

  beforeMount() {
    this.$bus.$on('closeAllModals', () => {
      this.show = false
    })
  }
}
